import React from "react";
import "../styles/Aboutus.css";

const AboutUs = () => {
  const message ="Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <section className="about-us-section" id="about-us">

      {/* Left Image Area */}
      <div className="about-us-image">
        <img
          src="About_ReddyAnna.webp"
          alt="About Us"
        />
      </div>

      {/* Right Content Area */}
      <div className="about-us-content">
        <h2>About <span className="highlight">Reddy Anna</span> Book</h2>
        {/* <p>
          Reddy Anna Book is a cricket betting and trading website that has
          been in operation since 2010. This service is regarded as the
          largest book exchange platform for cricket betting after Mahadev's
          book. It distinguishes itself from other exchange platforms due to
          its simple deposit and withdrawal options. Reddy Anna owns or
          operates this website. We communicate exclusively via WhatsApp.
        </p> */}
        <p>
        Welcome to a trusted legacy in fantasy cricket - a platform that has earned its reputation through reliability since 2010. Second only to the industry leader in size and reach, we pride ourselves on offering seamless transactions and a user-friendly experience. Experience personalized service through our dedicated WhatsApp support, where skilled professionals guide you every step of the way.
        </p>
        {/* <p>
          Reddy Anna cricket ID online has lately developed the most recent
          new methods of making money through betting. Users receive their
          cricket IDs promptly online, with 24-hour withdrawal services. With
          over 50,000 pleased consumers, this platform is at the top of the
          book exchange market. It currently has over 200 offline branches.
        </p> */}
        <p>
        Experience innovation in online fantasy cricket with cutting-edge features designed for today's players. Enjoy instant account activation and round-the-clock withdrawal support that puts you in control. Our platform stands as a market leader, trusted by a community of 50,000+ satisfied players and supported by an extensive network of 200 physical locations nationwide. Join the platform where convenience meets reliability.
        </p>

        {/* Buttons */}
        <div className="about-us-buttons">
          <a
           href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us @ 7777857777
          </a><br /><br />
          <a href="/about" class="more-about-link">
            More About Us <span class="tilted-arrow">&rarr;</span>
          </a>
        </div>
      </div>

    </section>
  );
};

export default AboutUs;
